const PREFIX = 'VIDEO/';

export const UPLOAD_VIDEO = `${PREFIX}UPLOAD_VIDEO`;
export const SELECT_VIDEO = `${PREFIX}SELECT_VIDEO`;
export const EDIT_VIDEO = `${PREFIX}EDIT_VIDEO`;
export const DELETE_VIDEO = `${PREFIX}DELETE_VIDEO`;

export const SEARCH_VIDEOS_TERM = `${PREFIX}SEARCH_VIDEOS_TERM`;
export const SEARCH_VIDEOS_EQUIPMENT = `${PREFIX}SEARCH_VIDEOS_EQUIPMENT`;
export const SEARCH_VIDEOS_FOCUS_AREA = `${PREFIX}SEARCH_VIDEOS_FOCUS_AREA`;
export const GET_VIDEOS = `${PREFIX}GET_VIDEOS`;

export const GET_FOCUS_AREAS = `${PREFIX}GET_FOCUS_AREAS`;
export const GET_EQUIPMENTS = `${PREFIX}GET_EQUIPMENTS`;

export const SET_PAGINATION = `${PREFIX}SET_PAGINATION`;

export const SELECT_VIDEO_CARD = `${PREFIX}SELECT_VIDEO_CARD`;
export const SET_DATE_RANGE = `${PREFIX}SET_DATE_RANGE`;
export const CLEAR_FILTERS = `${PREFIX}CLEAR_FILTERS`;
